/**
 * Three column carousel - carousel on tablet down
 * https://owlcarousel2.github.io/
 */

import 'imagesloaded';
import 'masonry-layout/masonry.js';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';

export function imageGallery() {
  if (jQuery(".image-gallery").length === 0) return;

  // Apply column count from data attributes
  jQuery('.image-gallery').each(function() {
    const colsDesktop = jQuery(this).data('cols-desktop');
    const colsMobile = jQuery(this).data('cols-mobile');
    if (colsDesktop) this.style.setProperty('--cols-desktop', colsDesktop);
    if (colsMobile) this.style.setProperty('--cols-mobile', colsMobile);
  });

  // Init Masonry layout
  jQuery('.image-gallery').imagesLoaded(function() {
    jQuery('.image-gallery').masonry({
      itemSelector: '.image-gallery__item',
      horizontalOrder: true,
      percentPosition: true
    });
  });

  // Short, unique name for a gallery image button: the alt text when the editor has
  // written one, otherwise just the position. The caption is not part of the name —
  // it can be a whole paragraph — but is linked as a description instead (see below).
  function buildImageLabel($img, index, total) {
    const alt = ($img.attr('alt') || '').trim();
    const position = `billede ${index + 1} af ${total}`;
    return alt ? `${alt} – ${position}` : `Billede ${index + 1} af ${total}`;
  }

  // Accessibility: wrap gallery images in <button> for semantic interactivity.
  // Scoped per .image-gallery so "billede X af Y" numbering is relative to
  // each gallery instance, not the whole page.
  const $allGalleries = jQuery('.image-gallery');
  $allGalleries.each(function(galleryIndex) {
    // Name each gallery so several on one page can be told apart.
    this.setAttribute('role', 'group');
    this.setAttribute('aria-label', $allGalleries.length > 1
      ? `Billedgalleri ${galleryIndex + 1} af ${$allGalleries.length}`
      : 'Billedgalleri');

    const $images = jQuery(this).find('img[data-src-viewer]');
    const total = $images.length;

    $images.each(function(index) {
      const $img = jQuery(this);

      const $btn = jQuery('<button>', {
        type: 'button',
        'aria-haspopup': 'dialog',
        'aria-label': buildImageLabel($img, index, total),
        class: 'image-gallery__trigger'
      });

      // The caption is read as the button's description, not its name.
      const caption = ($img.attr('data-caption') || '').trim();
      if (caption) {
        const captionId = `image-gallery-caption-${galleryIndex}-${index}`;
        $btn.attr('aria-describedby', captionId);
        jQuery('<span>', { id: captionId, hidden: true, text: caption }).insertAfter($img);
      }

      $img.wrap($btn);
      // Leave alt as-is: the button's aria-label wins for the accessible name
      // regardless (accname precedence), and ViewerJS reads this same alt
      // attribute for the lightbox image and thumbnails — blanking it here
      // was making the lightbox fall back to the file name (1.1.1).
    });
  });

  // Keyboard activation: Enter/Space on button triggers click on img inside so ViewerJS handles it
  jQuery(document).on('keydown', '.image-gallery__trigger', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      jQuery(this).find('img').trigger('click');
    }
  });

  // Focus trap: keeps Tab/Shift+Tab cycling inside the viewer while it is open.
  // Wraps on keydown (focus never leaves the dialog, so nothing outside is announced),
  // also when focus sits on the container itself or somewhere outside the list.
  // The open viewer's container, set in shown(): ViewerJS puts .viewer-open on <body>,
  // not on the container, so a selector can't find it.
  let openViewerEl = null;
  function handleFocusTrap(e) {
    if (e.key !== 'Tab') return;
    const viewerEl = openViewerEl;
    if (!viewerEl) return;

    const focusable = Array.from(viewerEl.querySelectorAll('a[href], button:not([disabled])'))
      .filter(el => el.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const current = focusable.indexOf(document.activeElement);

    if (e.shiftKey && current <= 0) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (current === -1 || current === focusable.length - 1)) {
      e.preventDefault();
      first.focus();
    }
  }

  // While the viewer is open everything else on the page is inert, so neither Tab
  // nor a screen reader's virtual cursor can reach it.
  let inertSiblings = [];
  function setPageInert(viewerEl) {
    inertSiblings = Array.from(document.body.children)
      .filter(el => el !== viewerEl && !el.contains(viewerEl) && !el.hasAttribute('inert'));
    inertSiblings.forEach(el => el.setAttribute('inert', ''));
  }
  function clearPageInert() {
    inertSiblings.forEach(el => el.removeAttribute('inert'));
    inertSiblings = [];
  }

  // ViewerJS falls back to the file name for an <img> with alt="" (image.alt ||
  // getImageNameFromURL(src)). Put the real alt back on every thumbnail and on the
  // viewed image, sourced from the gallery's own <img> so all three agree (1.1.1).
  function restoreAlts(gallery, viewer) {
    const sources = gallery.querySelectorAll('img[data-src-viewer]');
    viewer.viewer.querySelectorAll('.viewer-list img').forEach((thumb, i) => {
      if (sources[i]) thumb.alt = sources[i].getAttribute('alt') || '';
    });
    if (viewer.image && sources[viewer.index]) {
      viewer.image.alt = sources[viewer.index].getAttribute('alt') || '';
    }
  }

  // Initialize ViewerJS for each gallery
  const galleries = jQuery(".image-gallery");
  galleries.each(function(_, element) {
    // Index of the image on screen, so closing returns focus to that image's button.
    let lastIndex = 0;
    let viewerInstance = null;

    // Keyboard panning while zoomed (2.1.1): ViewerJS uses the arrow keys for prev/next and zoom only,
    // so a zoomed image could only be explored by dragging. When the image is larger than the screen the
    // arrows move it instead; Page Up/Down always switch image and +/- zoom. Capture phase, so it runs
    // before ViewerJS's own document listener.
    function onViewerKeydown(e) {
      const v = viewerInstance;
      if (!v || !v.isShown || !v.imageData || !v.viewerData) return;
      // ViewerJS clicks on Enter itself, and a native button/link clicks too, so the action ran twice (next skipped an image)
      if (e.key === 'Enter' && e.target.closest && e.target.closest('button, a[href]') && v.viewer.contains(e.target)) {
        e.stopPropagation();
        return;
      }
      const step = 60;
      const overflows = v.imageData.width > v.viewerData.width + 1 || v.imageData.height > v.viewerData.height + 1;
      let handled = true;
      switch (e.key) {
        case 'PageUp': v.prev(true); break;
        case 'PageDown': v.next(true); break;
        case '+':
        case '=': v.zoom(0.1, true); break;
        case '-': v.zoom(-0.1, true); break;
        case 'ArrowLeft': if (overflows) v.move(step, 0); else handled = false; break;
        case 'ArrowRight': if (overflows) v.move(-step, 0); else handled = false; break;
        case 'ArrowUp': if (overflows) v.move(0, step); else handled = false; break;
        case 'ArrowDown': if (overflows) v.move(0, -step); else handled = false; break;
        default: handled = false;
      }
      if (handled) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    viewerInstance = new Viewer(element, {
      backdrop: true,
      // Our own keydown trap + inert page replace ViewerJS's focusin enforcement,
      // which pulled focus back onto the container after it had already left.
      focus: false,
      button: true,
      inheritedAttributes: ['data-caption', 'data-src-download'],
      title(image) {
        return image.getAttribute('data-caption');
      },

      url(image) {
        return image.getAttribute('data-src-viewer') || image.src;
      },

      toolbar: {
        zoomIn:  { show: true, title: 'Zoom ind' },
        zoomOut: { show: true, title: 'Zoom ud' },
        prev:    { show: true, title: 'Forrige billede' },
        next:    { show: true, title: 'Næste billede' },
      },

      transition: false,

      // The zoom tooltip is aria-hidden, so announce the zoom level (and how to pan) in the live region
      zoomed(e) {
        const v = this.viewer;
        const liveRegion = v.viewer.querySelector('.image-gallery__live-region');
        if (!liveRegion || !e.detail) return;
        const overflows = v.imageData && v.viewerData &&
          (v.imageData.width > v.viewerData.width + 1 || v.imageData.height > v.viewerData.height + 1);
        liveRegion.textContent = `Zoom ${Math.round(e.detail.ratio * 100)} %` +
          (overflows ? '. Brug piletasterne til at flytte billedet og Page Up/Page Down til at skifte billede.' : '');
      },

      shown() {
        const viewerEl = this.viewer.viewer;

        // The trigger buttons already declare aria-haspopup="dialog" — make the
        // viewer container actually be the dialog they promise: role, modal
        // state, and an accessible name (viewer-title is often empty when the
        // image has no caption, so a static label is the reliable choice).
        viewerEl.setAttribute('role', 'dialog');
        viewerEl.setAttribute('aria-modal', 'true');
        viewerEl.setAttribute('aria-label', 'Billedfremviser');
        // aria-labelledby (set by ViewerJS itself) wins over aria-label above
        // and points at .viewer-title, which is empty without a caption
        viewerEl.removeAttribute('aria-labelledby');

        // ViewerJS ships the thumbnail list as <ul role="navigation">, which
        // overrides the ul's own list role (its <li>s become orphaned listitems)
        // and plants a navigation landmark inside the dialog where it doesn't
        // belong. Strip the role so the <ul> is a plain list again, and move
        // the "group of thumbnails" semantics to a wrapper around it instead.
        const list = viewerEl.querySelector('.viewer-list');
        if (list && !list.closest('[data-thumbnail-group]')) {
          list.removeAttribute('role');
          const group = document.createElement('div');
          group.setAttribute('data-thumbnail-group', '');
          group.setAttribute('role', 'group');
          group.setAttribute('aria-label', 'Miniaturer');
          list.parentNode.insertBefore(group, list);
          group.appendChild(list);
        }

        // Live region for slide-change announcements
        let liveRegion = viewerEl.querySelector('.image-gallery__live-region');
        if (!liveRegion) {
          liveRegion = document.createElement('div');
          liveRegion.className = 'image-gallery__live-region visually-hidden';
          liveRegion.setAttribute('role', 'status');
          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.setAttribute('aria-atomic', 'true');
          viewerEl.appendChild(liveRegion);
        }

        // Replace ViewerJS's <li role="button"> thumbnails with real <button>s
        // (axe list/listitem violation — a <ul> whose children aren't <li> is
        // effectively a list with no items) and aria-selected, which isn't
        // valid on role="button", with aria-current
        viewerEl.querySelectorAll('.viewer-list > li[role="button"]').forEach(item => {
          if (item.querySelector(':scope > button')) return; // already converted

          const img = item.querySelector('img');
          const thumbBtn = document.createElement('button');
          thumbBtn.type = 'button';
          thumbBtn.setAttribute('data-viewer-action', 'view');
          thumbBtn.setAttribute('data-index', item.getAttribute('data-index'));
          if (item.hasAttribute('aria-selected')) {
            thumbBtn.setAttribute('aria-current', 'true');
          }
          if (img) {
            img.style.pointerEvents = 'none'; // click always resolves to the button
            thumbBtn.appendChild(img);
          }

          item.removeAttribute('role');
          item.removeAttribute('tabindex');
          item.removeAttribute('data-viewer-action');
          item.removeAttribute('data-index');
          item.removeAttribute('aria-selected');
          item.appendChild(thumbBtn);
        });

        // ViewerJS's toolbar buttons are <li role="button"> and the close button
        // is a <div role="button"> — Enter works because ViewerJS's own keydown
        // handler special-cases it globally, but Space does nothing (it isn't a
        // native button, so the browser never fires a click for it) and nothing
        // in a <ul> whose children aren't real listitems satisfies 1.3.1 either.
        // data-viewer-action is read directly off event.target, so moving it
        // onto a button doesn't change ViewerJS's own click handling.

        // Toolbar items: nest a plain <button> inside each <li>, leaving the
        // li's own class alone (it's what positions the ::before icon glyph —
        // copying it onto the button too would render that icon twice).
        viewerEl.querySelectorAll('.viewer-toolbar > ul > li[role="button"]').forEach(li => {
          if (li.querySelector(':scope > button')) return; // already converted
          const btn = document.createElement('button');
          btn.type = 'button';
          const action = li.getAttribute('data-viewer-action');
          if (action) btn.setAttribute('data-viewer-action', action);
          while (li.firstChild) btn.appendChild(li.firstChild);
          li.removeAttribute('role');
          li.removeAttribute('tabindex');
          li.removeAttribute('data-viewer-action');
          li.appendChild(btn);
        });

        // Close/mix button: a lone <div role="button">, not a <li> — replace
        // it outright, carrying its class over since nothing else holds it.
        let closeBtn = viewerEl.querySelector('.viewer-button');
        if (closeBtn && closeBtn.tagName !== 'BUTTON') {
          const btn = document.createElement('button');
          btn.type = 'button';
          Array.from(closeBtn.attributes).forEach(attr => {
            if (attr.name === 'role' || attr.name === 'tabindex') return;
            btn.setAttribute(attr.name, attr.value);
          });
          closeBtn.replaceWith(btn);
          closeBtn = btn;
        }
        if (closeBtn) closeBtn.setAttribute('aria-label', 'Luk fremviser');

        // Set aria-label on toolbar buttons (ViewerJS sets title, not aria-label)
        // — on the nested <button> now, since that's what actually receives focus
        const toolbarLabels = {
          'viewer-zoom-in':  'Zoom ind',
          'viewer-zoom-out': 'Zoom ud',
          'viewer-prev':     'Forrige billede',
          'viewer-next':     'Næste billede',
        };
        Object.entries(toolbarLabels).forEach(([cls, label]) => {
          const btn = viewerEl.querySelector('.' + cls + ' > button');
          if (btn) btn.setAttribute('aria-label', label);
        });

        restoreAlts(element, this.viewer);

        // Thumbnail buttons get the same short name as the gallery's own buttons; without
        // it, an image with no alt leaves its thumbnail button with no name at all.
        const $sources = jQuery(element).find('img[data-src-viewer]');
        viewerEl.querySelectorAll('.viewer-list button').forEach((thumbBtn, i) => {
          if ($sources[i]) thumbBtn.setAttribute('aria-label', buildImageLabel(jQuery($sources[i]), i, $sources.length));
        });

        // Move initial focus to close button so keyboard users land inside the dialog
        if (closeBtn) closeBtn.focus();

        // Activate focus trap
        openViewerEl = viewerEl;
        setPageInert(viewerEl);
        jQuery(document).on('keydown.galleryTrap', handleFocusTrap);
        window.addEventListener('keydown', onViewerKeydown, true);
      },

      hidden() {
        // Deactivate focus trap
        jQuery(document).off('keydown.galleryTrap');
        window.removeEventListener('keydown', onViewerKeydown, true);
        openViewerEl = null;
        clearPageInert();

        // Return focus to the button of the image that was on screen, not the one that opened the viewer
        const trigger = element.querySelectorAll('.image-gallery__trigger')[lastIndex];
        if (trigger) trigger.focus();
      },

      viewed() {
        const viewer = this.viewer;
        const container = viewer.viewer;
        const image = viewer.image;

        // Safeguard against undefined (in older ViewerJS builds)
        if (!image) return;

        lastIndex = viewer.index;
        restoreAlts(element, viewer);

        // ViewerJS re-sets aria-labelledby (-> empty .viewer-title) and
        // aria-selected (invalid on role="button") on every view change
        container.removeAttribute('aria-labelledby');
        container.querySelectorAll('.viewer-list > li').forEach(item => {
          const isActive = item.hasAttribute('aria-selected');
          item.removeAttribute('aria-selected');
          const thumbBtn = item.querySelector('button');
          if (thumbBtn) {
            if (isActive) thumbBtn.setAttribute('aria-current', 'true');
            else thumbBtn.removeAttribute('aria-current');
          }
        });

        // Announce the slide change
        const liveRegion = container.querySelector('.image-gallery__live-region');
        if (liveRegion) {
          const alt = (image.getAttribute('alt') || '').trim();
          // The caption (.viewer-title) is not linked to anything, so it is part of the announcement
          const caption = (image.getAttribute('data-caption') || '').trim();
          let announcement = `Billede ${viewer.index + 1} af ${viewer.length}`;
          if (alt) announcement += `: ${alt}`;
          if (caption) announcement += `. ${caption}`;
          liveRegion.textContent = announcement;
        }

        // Remove previous download button
        container.querySelector('.viewer-download')?.remove();

        // Read download attribute directly — fallback
        const downloadUrl = image.getAttribute('data-src-download');

        if (!downloadUrl) return;

        // Create the button
        const btn = document.createElement('a');
        btn.href = downloadUrl;
        btn.download = '';
        btn.className = 'viewer-download-btn';
        // Names the image, so the button is not the same for every image
        const downloadAlt = (image.getAttribute('alt') || '').trim();
        const downloadLabel = `Download billede ${viewer.index + 1} af ${viewer.length}` + (downloadAlt ? `: ${downloadAlt}` : '');
        btn.title = downloadLabel;
        btn.setAttribute('aria-label', downloadLabel);
        btn.innerHTML = '<div><span class="icon-download"></span></div>';

        // Click event
        btn.onclick = () => {
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = '';
          a.rel = 'noopener';
          document.body.appendChild(a);
          a.click();
          a.remove();
        };

        // In the toolbar, not floating over the footer: positioned absolutely it covered
        // thumbnails on narrow screens (2.4.11, 2.5.8).
        const toolbarItem = document.createElement('li');
        toolbarItem.className = 'viewer-download';
        toolbarItem.appendChild(btn);
        const toolbarList = container.querySelector('.viewer-toolbar > ul');
        (toolbarList || container).appendChild(toolbarItem);
      },

    });
  });
}

export default imageGallery;
